<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-form :inline="true">
            <el-form-item>
              <el-input
                size="mini"
                v-model="form.title"
                placeholder="输入发票抬头搜索"
                clearable
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                size="mini"
                v-model="form.houseName"
                placeholder="输入房产或项目名称搜索"
                clearable
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                size="mini"
                v-model="form.invoiceNo"
                placeholder="输入发票号码搜索"
                clearable
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="startDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="timestamp"
                placeholder="选择开始日期"
              />
              至
              <el-date-picker
                v-model="endDate"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="timestamp"
                placeholder="选择结束日期"
              />
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-wrap">
          <el-table
            :data="listData"
            border
          >
        <el-table-column label="发票抬头" prop="title" width="150" />
        <el-table-column label="纳税人识别号" width="180">
          <template slot-scope="scope">
            <b>{{ scope.row.tax_number }}</b>
          </template>
        </el-table-column>
        <el-table-column label="合同名称" prop="contract_name" width="200" />
        <el-table-column label="开票金额" prop="amount" width="100" />
        <el-table-column label="税额" prop="tax_amount" width="100"></el-table-column>
        <el-table-column label="发票号码" prop="invoice_no" width="120" />
        <el-table-column label="发票代码" prop="invoice_code" width="120" />
        <el-table-column label="备注" prop="remark" width="150" />
        <el-table-column label="开票时间" prop="date" width="150" />
        <el-table-column label="是否红冲" prop="is_canceled" width="100" />
        <el-table-column label="红冲时间" prop="canceled_at" width="150" />
        <el-table-column label="红冲原因" prop="red_reason" width="150"></el-table-column>
        <el-table-column label="操作" width="230" fixed="right">
          <template slot-scope="data">
            <el-button size="mini" type="text" @click="viewInvoiceUrl(data.row.invoice_id, 1)">查看发票</el-button>
            <el-button size="mini" type="text" v-if="data.row.is_canceled === '未红冲'"
                       @click="canceledInvoice(data.row.invoice_id)">红冲发票</el-button>
            <el-button size="mini" type="text" v-if="data.row.is_canceled === '已红冲'"
                       @click="viewInvoiceUrl(data.row.invoice_id, 2)">查看红冲发票</el-button>
            <el-button size="mini" type="text" @click="detail(data.row.invoice_id)">详情</el-button>
          </template>
        </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :page-size="form.pageSize"
                         :total="totalCount" :current-page.sync="form.page">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="确认红冲发票？" :visible.sync="canceledVisible" width="380px" @close="canceledVisible = false;">
        <el-form v-loading="cancelLoading">
          <el-form-item label="税盘">
            <el-select v-model="selectedDiscId" placeholder="请选择税盘" clearable style="width: 100%;">
              <el-option
                v-for="item in discList"
                :key="item.id"
                :label="'税号：' + item.tax_number + ' 开票人：' + item.drawer + ' 备注：' + item.remark"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="红冲原因">
            <el-input v-model="redReason" type="textarea" placeholder="请输入红冲原因" rows="3" maxlength="200">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canceledInvoiceSave" size="small">确定</el-button>
            <el-button @click="canceledVisible = false" size="small">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

    <invoice-detail v-if="invoiceId > 0" :invoiceId="invoiceId" :visible="invoiceDetailVisible"
                    @close="invoiceDetailVisible = false"></invoice-detail>
  </div>

</template>

<script>
import AreaTree from "./components/AreaTree";
import InvoiceDetail from "./InvoiceDetail.vue";

export default {
  name: "ContractInvoiceList",
  components: {
    AreaTree,
    InvoiceDetail,
  },
  data() {
    return {
      listData: [],
      form: {
        title: "",
        houseName: "",
        invoiceNo: "",
        startDate: "",
        endDate: "",
        pid: "",
        page: 1,
        pageSize: 10,
      },
      startDate: "",
      endDate: "",
      totalCount: 0,

      canceledVisible: false,
      cancelId: 0,
      cancelLoading: false,
      redReason: '',
      discList: [],  // 税盘列表
      selectedDiscId: '',  // 选中的税盘ID

      invoiceId: 0,
      invoiceDetailVisible: false,
    };
  },
  mounted() {
    // startDate 默认当月1号
    let firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.startDate = firstDay.getTime();
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      // area-tree 返回的数据结构: {level, type, id, name, tree}
      this.form.pid = data.id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      
      // 获取税盘列表
      this.getDiscList(data.id);
    },
    search() {
      if (this.form.pid === '') {
        this.$message.error("请选择项目");
        return;
      }

      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.$myhttp
        .post("contract/Invoice/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    viewInvoiceUrl(id, type) {
      this.$myhttp
        .post(
          "contract/Invoice/getInvoiceUrl",
          { id, type },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            window.open(backdata.data.url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    canceledInvoiceSave() {
      if (!this.selectedDiscId) {
        this.$message.error('请选择税盘');
        return;
      }
      
      this.cancelLoading = true;
      this.$myhttp
        .post(
          "contract/Invoice/canceledInvoice",
          {
            id: this.cancelId,
            reason: this.redReason,
            disc_id: this.selectedDiscId
          },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.cancelLoading = false;
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.canceledVisible = false;
            this.redReason = '';
            this.selectedDiscId = '';
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.cancelLoading = false;
          this.$message.error(err);
        });
    },
    canceledInvoice(id) {
      this.cancelId = id;
      this.redReason = '';
      this.selectedDiscId = '';
      this.canceledVisible = true;
    },
    // 获取税盘列表
    getDiscList(areaId) {
      if (!areaId) {
        this.discList = [];
        return;
      }
      
      this.$myhttp
        .get("contract/InvoiceDisc/getInvoiceDiscList", {
          area_id: areaId
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.discList = backdata.data.data.list || backdata.data.data || [];
            
            // 如果只有一个税盘，自动选中
            if (this.discList.length === 1) {
              this.selectedDiscId = this.discList[0].id;
            }
          } else {
            this.discList = [];
          }
        })
        .catch((err) => {
          console.error('获取税盘列表失败:', err);
          this.discList = [];
        });
    },
    detail(id) {
      this.invoiceId = id;
      this.invoiceDetailVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './common.scss';

.table-wrap {
  width: calc(100vw - 330px);
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/InvoiceList.vue